import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import "../App.css";
import TopNav from "../components/TopNav";

function UploadJob() {
  const [form, setForm] = useState({
    name: "",
    desc: "",
    place: "",
    salary: "",
    type: "",
    occ: "",
    image: "",
  });

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
const [tagInput, setTagInput] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      await addDoc(collection(db, "items"), {
        ...form,
        desc: form.desc.replace(/\n/g, "<br>"),
        uploaded_date: serverTimestamp(),
      });
      setSuccess(true);
      setForm({ name: "", desc: "", place: "", salary: "", type: "", occ: "", image: ""});
    } catch (err) {
      alert("Failed to upload job: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <TopNav />
      <div className="upload_section">
        <h1 className="auth-heading upload">Upload Job</h1>
        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Job Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="url"
            name="image"
            placeholder="Image URL (optional)"
            value={form.image}
            onChange={handleChange}
          />
          <textarea
            name="desc"
            placeholder="Job Description (line breaks supported)"
            value={form.desc}
            onChange={handleChange}
            className="textarea-input"
            required
          />
          <input
            type="text"
            name="place"
            placeholder="Location"
            value={form.place}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="salary"
            placeholder="Salary (optional)"
            value={form.salary}
            onChange={handleChange}
          />
          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            required
          >
            <option value="">Select Job Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </select>
          <input
            type="text"
            name="occ"
            placeholder="Occupation Category (e.g. Logistics, Food Service)"
            value={form.occ}
            onChange={handleChange}
            required
          />

<div className="tag-section">
  <input
    type="text"
    value={tagInput}
    onChange={(e) => setTagInput(e.target.value)}
    placeholder="Add tag and press Enter"
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (tagInput.trim() && tags.length < 10 && !tags.includes(tagInput.trim())) {
          setTags([...tags, tagInput.trim()]);
          setTagInput("");
        }
      }
    }}
  />
  <div className="tag-list">
    {tags.map((tag, index) => (
      <span key={index} className="tag">
        {tag}
        <button onClick={() => setTags(tags.filter((_, i) => i !== index))}>×</button>
      </span>
    ))}
  </div>
  {tags.length >= 10 && <p className="tag-warning">You can only add up to 10 tags.</p>}
</div>


          {success && (
            <p className="success-text">Job uploaded successfully!</p>
          )}

          <button
            className="auth-btn login_btn"
            type="submit"
            disabled={loading}
          >
            {loading ? <span className="loader"></span> : "Upload"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default UploadJob;
